import { Box } from '@mui/material';

import { DraggableList } from '@shared/components/draggable/DraggableList';
import { UserListLabel, UsersListWrapper } from '@styles/Admin-tools/TeamManagerStyle';

import { NTeamManager } from '../interfaces';

interface IManagerProps {
  height?: string;
  label?: string;
  droppableId: string;
  data?: NTeamManager.User[];
  showScroll?: boolean;

  onChange?(value: NTeamManager.User): void;
}

// function getStyle({ provided, style, isDragging }: object) {
// If you don't want any spacing between your items
// then you could just return this.
// I do a little bit of magic to have some nice visual space
// between the row items
// 	const combined = {
// 		...style,
// 		...provided.draggableProps.style,
// 	};

// 	const marginBottom = 8;
// 	const withSpacing = {
// 		...combined,
// 		height: isDragging ? combined.height : combined.height - marginBottom,
// 		marginBottom,
// 	};
// 	return withSpacing;
// }

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
// function Item({ provided, item, style, isDragging }: object) {
// 	return (
// 		<ListItem
// 			key={item.userId}
// 			disablePadding
// 			{...provided.draggableProps}
// 			{...provided.dragHandleProps}
// 			ref={provided.innerRef}
// 		>
// 			<ListItemButton dense>
// 				<ListItemText primary={item.userName} />
// 			</ListItemButton>
// 		</ListItem>
// 	);
// }

export const UsersList = ({ height, label, data = [], droppableId, showScroll = false, }: IManagerProps) => {
  return (
    <UsersListWrapper height={height}>
      <UserListLabel filled>{label}</UserListLabel>

      <Box sx={{ height: '100%' }}>
        <DraggableList
          showScroll={showScroll}
          droppableId={droppableId}
          items={data.map(({ userId, userName }) => ({ id: userId, text: userName }))}
        />
      </Box>
    </UsersListWrapper>
  );
};
